import type { Effect } from "./effect";
import type { EffectGroup } from "./skill";

/** 魂印声明；效果运行状态由持有者在战斗准备阶段独立克隆。 */
export class Soulmark {
    /**
     * 创建实例并初始化所需的领域状态。
     * @param description description参数，参与本次操作
     * @param effectGroup effectGroup参数，参与本次操作；默认值为 `[]`
     */
    constructor(
        public description: string[],
        public effectGroup: EffectGroup = [],
    ) {}
}

/** 战斗初始化时建立的候选声明；参数状态只在实际持有的实例中演进。 */
export interface SoulmarkEffectCandidate {
    /**
     * definition，保存当前实例的definition状态。
     */
    definition: Effect;
    /**
     * targetId，保存当前实例的targetId状态。
     */
    targetId: number;
    /**
     * bindEnemy，保存当前实例的bindEnemy状态。
     */
    bindEnemy: boolean;
}
